import { Component } from "@angular/core";
import { LicenseService } from "../../services/LicenseService";
import { MdDialog, MdDialogRef } from "@angular/material";
import { GenerateSmartLink360LicenseComponent } from "./generate-smartlink360-license/generate-smartlink360-license.component";
import { generate } from "rxjs/observable/generate";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { apply } from "core-js/fn/reflect";
import { SmartLink360ViewActivationDetailComponent } from "./smartlink360-view-activation-details/smartlink360-view-activation-details.component";
import { Smartlink360RenewLicenseComponent } from "./smartlink360-renew-license/smartlink360-renew-license.component";
import { SmartLink360ViewRenewalHistoryComponent } from "./smartlink360-view-renewal-history/smartlink360-view-renewal-history.component";
import { SmartLink360ViewFeedbackComponent } from "./smartlink360-view-feedback/smartlink360-view-feedback.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import { ExportToCSVService } from "../../services/ExportToCSVService";
import Swal from "sweetalert2";
import { PagerService } from "../../services/PagerService";
import { UserService } from "../../services/UserService";
import { FilterPipe } from "../../pipes";
import { LicenseFilterPipe } from "../filter.pipe";
import { Service360FilterPipe } from "../service360/pipes/service360FilterPipe";

@Component({
    selector:'license-smartlink360',
    template:require('./smartlink360.component.html'),
    styles:[require('./smartlink360.component.css')],
})
export class LicenseModuleSmartlink360Component{
    originalDemoLicenseData=[];
    demoLicenseData=[];
    filteredDemoLicenseData=[];
    searchName='';
    searchEmailId='';
    searchMobileNo='';
    searchShipTo='';
    searchBillTo='';
    searchDemoLicenseKey='';
    searchPurchaseLicenseKey=''
    filterName='';
    filterEmailId='';
    filterMobileNo='';
    filterDemoLicenseKey='';
    filterBillTo='';
    filterShipTo='';
    filterPurchaseLicenseKey='';
    originalSmartlinkPurchaseLicenseDetailList=[];
    smartlinkPurchaseLicenseDetailList=[];
    filteredPurchaseLicenseDetailList=[];
    error='';
    BillToList=[];
    ShipToList=[];
    demoPager:any={};
    demoPageItems=[];
    purchasePager:any={};
    purchasePageItems=[];
    IsAddEdit;
    errorMessageDemoPage="";
    errorMessagePurchasePage=""
    IsDelete;
    ProductId;
    purchaseCurrentSortOrder='';
    purchaseCurrentSortColumn='';
    demoCurrentSortOrder='';
    demoCurrentSortColumn='';
    constructor(
        private licenseService:LicenseService, 
        private dialog:MdDialog,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        private exportService:ExportToCSVService,
        private pagerService:PagerService,
        private route:ActivatedRoute,
        private userService:UserService,
        private demoFilterPipe:LicenseFilterPipe,
        private purchaseFilterPipe:Service360FilterPipe
    ){
            if (!this.adalService.getCachedToken()) {
                setTimeout(() => {
                    this.router.navigate(["login"]);
                }, 100);
            }
            
                this.appLoader.open();
                route.params.subscribe((params)=>{
                    this.ProductId=params['productId']
                })
                this.getUserRights();
                this.getDemoLicenseData();
                this.getPurchaseLicenseData();
            
            // this.getCustomerDetails();
            // this.demoLicenseData=[{UserRegId:1,Name:'Freyal',EmailId:'freyal123@gmail.com', MobileNo:'345294197', Organization:'Sensit',ExpiryDate:'2021-12-01 14:30:15',LicenseType:'Demo',Status:'InActive',HardwareId:3147,LicenseKey:'2B7E-85E7'},
            //     {Name:'Freyal',EmailId:'freyal123@gmail.com', MobileNo:'345294197', Organization:'Sensit',ExpiryDate:'2021-12-01 14:30:15',LicenseType:'Demo',Status:'Active',HardwareId:3147,LicenseKey:'2B7E-85E7'}
            // ];
    }
    getUserRights(){
        let UserId=Number(localStorage.getItem('userid'))
        this.userService.getUserLicenseRightById(UserId,this.ProductId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.IsAddEdit=data.DataObject.IsAddEdit;
                this.IsDelete=data.DataObject.IsDelete;
            }
        })
    }
    getDemoLicenseData(){
        this.licenseService.getSmartLinkDemoData().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.originalDemoLicenseData=data.DataObject;
                this.demoLicenseData=[...this.originalDemoLicenseData];
                this.setPageForDemo(1);
            }
            else{
                this.error=data.Error;
            }
            this.appLoader.close();
        })
    }
    exportDemoLicenseInfoToCSV(){
        let jsonData:Array<any>=[];
        if(this.demoLicenseData){
            this.demoLicenseData.forEach(element => {
                jsonData.push({
                    Name:element.Name,
                    EmailId:element.EmailId,
                    MobileNo:element.MobileNo,
                    Organisation:element.Organization,
                    ExpiryDate:element.ExpiryDate,
                    LicenseType:element.LicenseType,
                    HardwareId:element.HardwareId,
                    LicenseKey:element.LicenseKey,
                    Status:element.Status
                })
            });
            this.exportService.exportToCsv(jsonData,'SmartLink360DemoLicense')
        }
        else{
            Swal.fire({
                title:'No data',
                text:'There is no data available to export to CSV file.',
                showCloseButton:true,
                showConfirmButton:true,
                confirmButtonColor:'#FFCA28'
            })
        }
    }
    exportPurchaseLicenseData(){
        let jsonData:Array<any>=[];
        if(this.smartlinkPurchaseLicenseDetailList){
            this.smartlinkPurchaseLicenseDetailList.forEach(element => {
                jsonData.push({
                    BillToName:element.BillToName,
                    BillToAddress1:element.BillToAddress1,
                    BillToAddress2:element.BillToAddress2,
                    BillToCity:element.BillToCity,
                    BillToState:element.BillToState,
                    BillToZipcode:element.BillToZipcode,
                    BillToCountryCode:element.BillToCountryCode,
                    ShipToName:element.ShipToName,
                    ShipToAddress1:element.ShipToAddress1,
                    ShipToAddress2:element.ShipToAddress2,
                    ShipToCity:element.ShipToCity,
                    ShipToState:element.ShipToState,
                    ShipToZipcode:element.ShipToZipcode,
                    ShipToCountryCode:element.ShipToCountryCode,
                    LicenseKey:element.LicenseKey,
                    SalesOrderNo:element.SalesOrderNo,
                    PurchaseDate:element.PurchaseDate,
                    NoOfMonths:element.NoOfMonths,
                    ExpiryDate:element.ExpiryDate
                })
            });
            this.exportService.exportToCsv(jsonData,'SmartLink360PurchaseLicense')
        }
        else{
            Swal.fire({
                title:'No data',
                text:'There is no data available to export to CSV file.',
                showCloseButton:true,
                showConfirmButton:true,
                confirmButtonColor:'#FFCA28'
            })
        }
    }
    setPageForDemo(page: number) {
        this.demoLicenseData=[...this.originalDemoLicenseData];
        this.demoApplySort();
        this.filteredDemoLicenseData=this.demoFilterPipe.transform(this.demoLicenseData,this.filterName,this.filterEmailId,this.filterMobileNo,this.filterDemoLicenseKey)
        this.demoPager = this.pagerService.getPager(this.filteredDemoLicenseData.length, page);
        this.demoPageItems = this.filteredDemoLicenseData.slice(this.demoPager.startIndex, this.demoPager.endIndex + 1);
        this.errorMessageDemoPage=(this.demoPageItems.length==0)?"No records found.":"";
    }
    setPageForPurchase(page: number) {
        this.smartlinkPurchaseLicenseDetailList=[...this.originalSmartlinkPurchaseLicenseDetailList];
        this.purchaseApplySort();
        this.filteredPurchaseLicenseDetailList=this.purchaseFilterPipe.transform(this.smartlinkPurchaseLicenseDetailList,this.filterBillTo,this.filterShipTo,this.filterPurchaseLicenseKey)
        this.purchasePager = this.pagerService.getPager(this.filteredPurchaseLicenseDetailList.length, page);
        this.purchasePageItems = this.filteredPurchaseLicenseDetailList.slice(this.purchasePager.startIndex, this.purchasePager.endIndex + 1);
        this.errorMessagePurchasePage=(this.purchasePageItems.length==0)?"No records found.":"";
    }

    buildSearchArray(){
        const BillToArray=this.smartlinkPurchaseLicenseDetailList.map(item=>item.BillToName)
        const ShipToArray=this.smartlinkPurchaseLicenseDetailList.map(item=>item.ShipToName)
        this.BillToList=Array.from(new Set(BillToArray)).sort();
        this.ShipToList=Array.from(new Set(ShipToArray)).sort();
    }
    getPurchaseLicenseData(){
        this.licenseService.getSmartLinkPurchaseLicenseDisplayDetail().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.originalSmartlinkPurchaseLicenseDetailList=data.DataObject;
                this.smartlinkPurchaseLicenseDetailList=[...this.originalSmartlinkPurchaseLicenseDetailList];
                this.buildSearchArray();
                this.setPageForPurchase(1);
            }
            else{
                this.error=data.Error;
            }
            this.appLoader.close();
        })
    }
    viewFeedback(row){
        let smartlinkFeedbackDialogRef:MdDialogRef<SmartLink360ViewFeedbackComponent>=this.dialog.open(SmartLink360ViewFeedbackComponent,{
            disableClose:true,
            width:'60%',
            height:'70%',
            data:{
                SelectedLicenseDetail:row,
            }
        })
    }
    // getCustomerDetails(){
    //     this.licenseService.getCustomerDetails().subscribe((data)=>{
    //         if(!data.IsError && data.DataObject!=null){
    //             console.log(data.DataObject);
    //         }
    //     })
    // }
    generateNewLicenseRequest(){
        let smartLinkGenerateNewLicenseRequestDialogRef:MdDialogRef<GenerateSmartLink360LicenseComponent>=this.dialog.open(GenerateSmartLink360LicenseComponent,{
            disableClose:true,
            data:{
                SelectedLicenseDetail:null,
                Smartlink360PurchaseLicenseData:this.originalSmartlinkPurchaseLicenseDetailList
            }
        });
        smartLinkGenerateNewLicenseRequestDialogRef.afterClosed().subscribe((result)=>{
                this.originalSmartlinkPurchaseLicenseDetailList=result;
                this.smartlinkPurchaseLicenseDetailList=[...this.originalSmartlinkPurchaseLicenseDetailList];
            this.setPageForPurchase(1);
        })
    }
    
    viewActivationDetail(row){
        let smartLinkViewActivationDetailialogRef:MdDialogRef<SmartLink360ViewActivationDetailComponent>=this.dialog.open(SmartLink360ViewActivationDetailComponent,{
            width:'40%',
            height:'60%',
            disableClose:true,
            data:{
                SelectedLicenseData:row,
                Smartlink360PurchaseLicenseData:this.originalSmartlinkPurchaseLicenseDetailList
            }
        })
    }
    onEdit(row){
        let editSmartLink360LicenseDataDialogRef:MdDialogRef<GenerateSmartLink360LicenseComponent>=this.dialog.open(GenerateSmartLink360LicenseComponent,{
            disableClose:true,
            data:{
                SelectedLicenseDetail:row,
                Smartlink360PurchaseLicenseData:this.originalSmartlinkPurchaseLicenseDetailList
            }
        })
        editSmartLink360LicenseDataDialogRef.afterClosed().subscribe((result)=>{
            this.originalSmartlinkPurchaseLicenseDetailList=result;
            this.smartlinkPurchaseLicenseDetailList=[...this.originalSmartlinkPurchaseLicenseDetailList];
            this.setPageForPurchase(this.purchasePager.currentPage);
        })
    }
    renewLicense(row){
        let renewScalLicenseDialogRef:MdDialogRef<Smartlink360RenewLicenseComponent>=this.dialog.open(Smartlink360RenewLicenseComponent,{
                    width:'60%',
                    height:'80%',
                    data:{
                        Smartlink360PurchaseLicenseData:this.originalSmartlinkPurchaseLicenseDetailList,
                        SelectedLicenseDetail:row,
                    }
                })
                renewScalLicenseDialogRef.afterClosed().subscribe((result)=>{
                    this.originalSmartlinkPurchaseLicenseDetailList=result;
                    this.smartlinkPurchaseLicenseDetailList=[...this.originalSmartlinkPurchaseLicenseDetailList];
                    this.setPageForPurchase(this.purchasePager.currentPage);
                })
    }
    viewRenewalHistory(row){
        let renewalHistoryDialogBox:MdDialogRef<SmartLink360ViewRenewalHistoryComponent>=this.dialog.open(SmartLink360ViewRenewalHistoryComponent,{
            width:'40%',
            height:'60%',
            data:{
                Smartlink360PurchaseLicenseData:this.purchasePageItems,
                SelectedLicenseDetail:row,
            }
        })
    }
    searchDemoLicenseInfo(){
        this.filterName=this.searchName;
        this.filterEmailId=this.searchEmailId;
        this.filterMobileNo=this.searchMobileNo;
        this.filterDemoLicenseKey=this.searchDemoLicenseKey;
        this.setPageForDemo(1);
    }
    clearDemoLicenseInfo(){
        this.searchName=this.filterName='';
        this.searchEmailId=this.filterEmailId='';
        this.searchMobileNo=this.filterMobileNo='';
        this.searchDemoLicenseKey=this.filterDemoLicenseKey='';
        this.setPageForDemo(1);
    }
    searchPurchaseLicenseInfo(){
        this.filterBillTo=this.searchBillTo;
        this.filterShipTo=this.searchShipTo;
        this.filterPurchaseLicenseKey=this.searchPurchaseLicenseKey;
        this.setPageForPurchase(1);
    }
    clearPurchaseLicenseInfo(){
        this.filterBillTo=this.searchBillTo='';
        this.filterShipTo=this.searchShipTo='';
        this.filterPurchaseLicenseKey=this.searchPurchaseLicenseKey='';
        this.setPageForPurchase(1);
    }
    onPurchaseSortChange(event){
        this.purchaseCurrentSortColumn = event.column;
        this.purchaseCurrentSortOrder = event.order;
        this.setPageForPurchase(this.purchasePager.currentPage);
    }
    purchaseApplySort(){
        if(!this.purchaseCurrentSortColumn || !this.purchaseCurrentSortOrder) return;
        this.smartlinkPurchaseLicenseDetailList=this.smartlinkPurchaseLicenseDetailList.sort((a,b)=>
            {
                if(this.purchaseCurrentSortOrder==='asc'){
                    a[this.purchaseCurrentSortColumn]=a[this.purchaseCurrentSortColumn] || '';
                    return a[this.purchaseCurrentSortColumn].localeCompare(b[this.purchaseCurrentSortColumn])
                }
                else if (this.purchaseCurrentSortOrder==='desc'){
                    b[this.purchaseCurrentSortColumn]=b[this.purchaseCurrentSortColumn] || '';
                    return b[this.purchaseCurrentSortColumn].localeCompare(a[this.purchaseCurrentSortColumn])
                }
                else {
                    return 0;
                }
            }
        )
    }
    onDemoSortChange(event){
        this.demoCurrentSortColumn = event.column;
        this.demoCurrentSortOrder = event.order;
        this.setPageForDemo(this.demoPager.currentPage);
    }
    demoApplySort(){
        if(!this.demoCurrentSortColumn || !this.demoCurrentSortOrder) return;
        this.demoLicenseData=this.demoLicenseData.sort((a,b)=>
            {
                if(this.demoCurrentSortOrder==='asc'){
                    a[this.demoCurrentSortColumn]=a[this.demoCurrentSortColumn] || '';
                    return a[this.demoCurrentSortColumn].localeCompare(b[this.demoCurrentSortColumn])
                }
                else if (this.demoCurrentSortOrder==='desc'){
                    b[this.demoCurrentSortColumn]=b[this.demoCurrentSortColumn] || '';
                    return b[this.demoCurrentSortColumn].localeCompare(a[this.demoCurrentSortColumn])
                }
                else {
                    return 0;
                }
            }
        )
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartlink360/smartlink360.component.ts